import { KTCard } from "../../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../../_metronic/helpers/components/KTCardBody";
import { GetAmbarVoyageByIdResponseAmbar } from "../../../../models/response/ambarVoyage/GetAmbarVoyageByIdResponse";
import { gelirToplamiMetni, gelirToplamlariniBirlestir, kmBirimMetni, kmMetni, seferKmToplami, tekDovizKodu } from "../../../../helpers/seferFiyat";
import StatusBadge from "../../../../components/StatusBadge";
import { useState } from "react";
import { useDispatch } from "react-redux";
import toast from "react-hot-toast";
import { storeActivityIndicator } from "../../../../redux/reducers/authSlice";
import { AmbarVoyageService } from "../../../../services/AmbarVoyageService";
import { SeferGuzergahData, SeferGuzergahResponse } from "../../../../models/response/ambarVoyage/SeferGuzergahResponse";
import { birYukari, ilkSiraIsaretle, siraNumarala, siraUygula } from "../../../../helpers/seferGuzergahi";
import GuzergahHaritasi from "./GuzergahHaritasi";

interface Props {
    ambarVoyageId: string | undefined
    ambars: GetAmbarVoyageByIdResponseAmbar[]
    setAmbars: React.Dispatch<React.SetStateAction<GetAmbarVoyageByIdResponseAmbar[]>>
}

const Orders = ({
    ambarVoyageId,
    ambars,
    setAmbars
}: Props) => {
    const dispatch = useDispatch();
    // Guzergah Goster acikken tablo yerine harita gorunur; Geri tabloya doner.
    const [guzergah, setGuzergah] = useState<SeferGuzergahData | undefined>(undefined);
    // Sira ekranda degistiyse KM / fiyat kolonlari eski sirayi gosterir (Kaydet + Fiyat Bul ile guncellenir).
    const [siraDegisti, setSiraDegisti] = useState(false);

    /**
     * Sefer guzergahi (15.10.2026): ilkAmbarId 1. sirada sabit (Elle 1. sira), kalanlar sunucunun en az KM onizlemesiyle
     * dizilir; ilkAmbarId bos ise tamami otomatik. Kaydedilmemis seferde onizleme yok, yalniz liste islemi yapilir.
     */
    const otomatikDiz = async (_ilkAmbarId: string | undefined, _liste: GetAmbarVoyageByIdResponseAmbar[]) => {
        const isaretli = ilkSiraIsaretle(_liste, _ilkAmbarId ?? null);

        if (!ambarVoyageId) {
            setAmbars(_ilkAmbarId ? siraUygula(isaretli, [_ilkAmbarId]) : isaretli);
            setSiraDegisti(true);
            return;
        }

        try {
            dispatch(storeActivityIndicator(true));
            var response: SeferGuzergahResponse = await AmbarVoyageService.guzergahDiz(ambarVoyageId, _ilkAmbarId);

            if (!response.isSuccess) {
                toast.error(response.message);
                return;
            }

            setAmbars(siraUygula(isaretli, response.data.duraklar.map(x => x.ambarId)));
            setSiraDegisti(true);
        } catch (error: any) {
            toast.error(error);
        } finally {
            dispatch(storeActivityIndicator(false));
        }
    }

    const enUsteAl = (_ambarId: string) => otomatikDiz(_ambarId, ambars);

    const birYukariTasi = (_ambarId: string) => {
        const sonuc = birYukari(ambars, _ambarId);

        // En uste geldiyse Elle 1. sira olur ve kalanlar dizilir; orta siralarda yalniz yer degisir.
        if (sonuc.enUste)
            otomatikDiz(_ambarId, sonuc.liste);
        else {
            setAmbars(siraNumarala(sonuc.liste));
            setSiraDegisti(true);
        }
    }

    const guzergahGoster = async () => {
        if (!ambarVoyageId)
            return;

        try {
            dispatch(storeActivityIndicator(true));
            var response: SeferGuzergahResponse = await AmbarVoyageService.guzergah(ambarVoyageId, ambars.map(x => x.ambarId));

            if (!response.isSuccess) {
                toast.error(response.message);
                return;
            }

            setGuzergah(response.data);
        } catch (error: any) {
            toast.error(error);
        } finally {
            dispatch(storeActivityIndicator(false));
        }
    }

    // Sefer toplami: siparislerin gelir toplamlari doviz cinsine gore birlesir; birden cok doviz -> "Farkli Doviz Cinsi".
    const seferToplami = gelirToplamlariniBirlestir(ambars.map(x => x.gelirToplamlari));
    // Toplama - Dagitim KM zinciri: dolu KM'lerin toplami (hicbiri dolu degilse "—").
    const seferKm = seferKmToplami(ambars.map(x => x.seferKm));

    return (
        <div className='containerPart'>
            <KTCard className="ebbe-card mt-10">
                <KTCardBody>
                    {
                        guzergah ? (
                            <GuzergahHaritasi veri={guzergah} onGeri={() => setGuzergah(undefined)} />
                        ) : (
                            <>
                                <div className="d-flex align-items-center mb-10">
                                    <h4 className="text-black m-0 flex-grow-1">Siparişler</h4>
                                    {
                                        ambars.length > 0 && (
                                            <button
                                                className="btn btn-primary btn-sm"
                                                onClick={guzergahGoster}
                                                disabled={!ambarVoyageId}
                                                title={ambarVoyageId ? 'Siparişlerin teslim sırasını haritada göster' : 'Önce seferi kaydedin'}
                                            >
                                                <i className="fa fa-route me-2" />Güzergah Göster
                                            </button>
                                        )
                                    }
                                </div>

                                <div className="row mt-5">
                                    <div className="col-md-12">
                                        <div className='table-responsive'>
                                            <table id='kt_table_users' className='table align-middle table-row-dashed dataTable no-footer'>
                                                <thead>
                                                    <tr className='text-start text-muted fw-bolder text-uppercase'>
                                                        <th style={{ width: '1px' }}></th>
                                                        <th style={{ width: '1px' }}>Sıra</th>
                                                        <th>Ref No</th>
                                                        <th>Müşteri</th>
                                                        <th>Teslim Firması</th>
                                                        <th>İl / İlçe</th>
                                                        <th>Ek Lokasyon</th>
                                                        <th className="custom-text-right">KM</th>
                                                        <th className="custom-text-right">KM Birim Fiyat</th>
                                                        <th className="custom-text-right">Beklenen Gelir</th>
                                                        <th className="custom-text-right">Brüt Toplam</th>
                                                        <th>Adres</th>
                                                        <th style={{ width: '1px' }}>Konum</th>
                                                    </tr>
                                                </thead>
                                                <tbody className='text-gray-600 fw-bold'>
                                                    {
                                                        ambars.length == 0 && (
                                                            <tr>
                                                                <td className="text-center" colSpan={99}>Kayıt bulunamadı.</td>
                                                            </tr>
                                                        )
                                                    }
                                                    {
                                                        ambars.map((item, index) =>
                                                            <tr key={item.ambarId}>
                                                                <td className="text-nowrap">
                                                                    {
                                                                        index > 0 && (
                                                                            <>
                                                                                <a
                                                                                    onClick={() => enUsteAl(item.ambarId)}
                                                                                    href="javascript:;"
                                                                                    title="En üste al (ilk teslim)"
                                                                                    className="me-2"
                                                                                >
                                                                                    <i className="fa fa-angles-up text-primary fs-6" />
                                                                                </a>
                                                                                <a
                                                                                    onClick={() => birYukariTasi(item.ambarId)}
                                                                                    href="javascript:;"
                                                                                    title="Bir yukarı"
                                                                                >
                                                                                    <i className="fa fa-arrow-circle-up text-primary fs-6" />
                                                                                </a>
                                                                            </>
                                                                        )
                                                                    }
                                                                </td>
                                                                <td className="text-nowrap">
                                                                    {index + 1}
                                                                    {
                                                                        item.elleIlkSira && (
                                                                            <span className="badge badge-light-warning ms-2" title="Elle 1. sıra: otomatik dizim bu siparişe dokunmaz">
                                                                                İlk teslim
                                                                                <a
                                                                                    onClick={() => otomatikDiz(undefined, ambars)}
                                                                                    href="javascript:;"
                                                                                    className="ms-2 text-warning"
                                                                                    title="İlk teslim işaretini kaldır; sefer otomatik dizilsin"
                                                                                >×</a>
                                                                            </span>
                                                                        )
                                                                    }
                                                                </td>
                                                                <td><a onClick={() => window.open(window.location.href.split('=')[0].replace('ambarvoyage', 'ambar') + "=" + item.ambarId, "_blank")} href='javascript:;'>{item.refNo}</a></td>
                                                                <td>{item.customerName}</td>
                                                                <td>{item.deliverFirmCustomerName}</td>
                                                                <td>{item.deliverCountyName} / {item.deliverDistrictName}</td>
                                                                <td><StatusBadge text={item.isAdditionalLocation ? 'Evet' : 'Hayır'} /></td>
                                                                <td className="custom-text-right">{kmMetni(item.seferKm)}</td>
                                                                <td className="custom-text-right">{kmBirimMetni(item.seferKmBirimFiyat, tekDovizKodu(item.gelirToplamlari))}</td>
                                                                <td className="custom-text-right">{gelirToplamiMetni(item.gelirToplamlari, 'net')}</td>
                                                                <td className="custom-text-right">{gelirToplamiMetni(item.gelirToplamlari, 'brut')}</td>
                                                                <td>{item.deliverFirmCustomerAddressText}</td>
                                                                <td className="text-center">
                                                                    {
                                                                        (item.deliverFirmCustomerAddressLat && item.deliverFirmCustomerAddressLon) && (
                                                                            <a
                                                                                onClick={() => window.open(`https://www.google.com/maps/search/?api=1&query=${item.deliverFirmCustomerAddressLat},${item.deliverFirmCustomerAddressLon}`, "_blank")}
                                                                                href="javascript:;"
                                                                            >
                                                                                <i className="fa fa-location text-primary fs-6" />
                                                                            </a>
                                                                        )
                                                                    }
                                                                </td>
                                                            </tr>
                                                        )
                                                    }
                                                </tbody>
                                                {
                                                    ambars.length > 0 && (
                                                        <tfoot>
                                                            <tr className="ebbe-dip-toplam">
                                                                <td></td>
                                                                <td></td>
                                                                <td colSpan={5} className="custom-text-right">Sefer toplamı</td>
                                                                <td className="custom-text-right">{kmMetni(seferKm)}</td>
                                                                <td></td>
                                                                <td className="custom-text-right">{gelirToplamiMetni(seferToplami, 'net')}</td>
                                                                <td className="custom-text-right">{gelirToplamiMetni(seferToplami, 'brut')}</td>
                                                                <td colSpan={2}></td>
                                                            </tr>
                                                        </tfoot>
                                                    )
                                                }
                                            </table>
                                        </div>
                                        {
                                            siraDegisti && (
                                                <div className="text-muted fs-7 mt-3">
                                                    Sıra değişti. KM ve fiyat kolonları eski sırayı gösteriyor; Kaydet'ten sonra Fiyat Bul ile yeni sıraya göre hesaplanır.
                                                </div>
                                            )
                                        }
                                    </div>
                                </div>
                            </>
                        )
                    }
                </KTCardBody>
            </KTCard>
        </div>
    )
}

export default Orders;
